import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import router from "./router"
import VueGtag from "vue-gtag"

if (location.hostname.match(/(rach.kings.kucits.ca)|(tomo.kings.kucits.ca)/gi)) {
  Vue.config.devtools = true
  Vue.config.productionTip = false
}else {
  // Production
  Vue.use(VueGtag, {
    config: {
      id: "G-7W9SZHQF5B" 
    },
    appName: 'sfs-portal',
    pageTrackerScreenviewEnabled: true
  }, router);
}

new Vue({
  vuetify,
  router,
  render: h => h(App)
}).$mount('#app')
